import { axiosClient } from "./axiosClient"

export const USER_PATH = '/api/v1/user'

export const addUser = (body) => {
    return axiosClient.post(USER_PATH, body)
}

export const updateUser = (id, body) => {
    return axiosClient.put(`${USER_PATH}/${id}`, body)
}

export const deleteUser = (id) => {
    return axiosClient.delete(`${USER_PATH}/${id}`)
}

export const getUserById = (id) => {
    return axiosClient.get(`${USER_PATH}/${id}`)
}

export const getPageUsers = ({ page = 0, size = 20 }) => {
    return axiosClient.get(`${USER_PATH}/page?page=${page}&size=${size}`)
}

export const changeUserPassword = (id, body) => {
    return axiosClient.put(`${USER_PATH}/update-password/${id}`, body)
}

export const login = (body) => {
    return axiosClient.post(`/api/v1/auth`, body)
}

export const setAuthorizationHeader = ({ isLoggedIn, token }) => {
    if (isLoggedIn) {
        const authorizationHeaderValue = `Bearer ${token}`;
        axiosClient.defaults.headers['Authorization'] = authorizationHeaderValue;
    } else {
        delete axiosClient.defaults.headers['Authorization'];
    }
};